import { createContext, useContext } from "react";

// Provides guest-gating to nested components. When isGuest is true, gate(fn)
// shows the signup prompt and returns false instead of running fn.
export const GateContext = createContext({
  isGuest: false,
  gate: (fn) => (fn ? fn() : true),
});

export const useGate = () => useContext(GateContext);
